import { useParams, useSearchParams, useLocation } from 'react-router-dom';
import VendableInfoContainer from '../../../components/molecules/VendableInfoContainer/VendableInfoContainer';
import ROUTE_NAME from '@rabbit/olive/utils/url-constants';

interface VendablePreviewViewProps {
  vendableId?: string;
  onChangeStep?: (step_in: number, data?: any) => void;
}

export function VendablePreviewView({
  vendableId,
  onChangeStep,
}: VendablePreviewViewProps) {
  const { id } = useParams();
  const location = useLocation();
  const [search] = useSearchParams();
  const queryHoldingId = search.get('holdingId');
  // Fallback: support /landing/new-product/:vendableId/:holdingId style
  const segments = location.pathname.split('/').filter(Boolean);
  const lastSegment = segments[segments.length - 1];
  const holdingId = queryHoldingId ?? (lastSegment !== id ? lastSegment : null);

  if (vendableId && holdingId) {
    return (
      <VendableInfoContainer
        onChangeStep={onChangeStep}
        docid={vendableId}
        holdingId={holdingId}
      />
    );
  }
  if (!vendableId && id && holdingId) {
    return (
      <VendableInfoContainer
        onChangeStep={onChangeStep}
        docid={id}
        holdingId={holdingId}
      />
    );
  }
  if (location.pathname.startsWith(ROUTE_NAME.PRODUCTS_PREVIEW) && id) {
    return (
      <div className="w-full max-w-[1024px] px-4 sm:px-6 lg:px-0 mx-auto">
        <VendableInfoContainer docid={id} />
      </div>
    );
  }
  if (vendableId) {
    return (
      <VendableInfoContainer
        onChangeStep={onChangeStep}
        docid={vendableId}
        landing={true}
      />
    );
  }

  if (id) return <VendableInfoContainer docid={id} />;
  return null;
}

export default VendablePreviewView;
